var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h32v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-746-4340H982v8104H-746z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#C7C7C7",
    d: "M42.01-15.5H-10a3.48 3.48 0 0 0-3.5 3.5v52a3.5 3.5 0 0 0 3.5 3.5h52a3.5 3.5 0 0 0 3.5-3.5v-52a3.5 3.5 0 0 0-3.49-3.5Z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m2.94 12 2.88-8.45a.6.6 0 0 1 .57-.4h1.63a.6.6 0 0 1 .57.4l2.87 8.46a.6.6 0 0 1-.57.79H9.74a.6.6 0 0 1-.57-.43l-.47-1.6H5.69l-.46 1.6a.6.6 0 0 1-.57.43H3.51a.6.6 0 0 1-.56-.8ZM0 1.2v13.6c0 .66.54 1.2 1.2 1.2h14V0h-14C.54 0 0 .54 0 1.2ZM29.6 6a.6.6 0 0 1-.6.6h-.57a8.96 8.96 0 0 1-2.13 3.5c.41.31.85.62 1.3.9a.6.6 0 0 1 .2.8l-.39.7a.6.6 0 0 1-.84.21 17.4 17.4 0 0 1-1.77-1.24c-.54.43-1.13.85-1.77 1.24a.6.6 0 0 1-.83-.21l-.4-.7a.6.6 0 0 1 .21-.8c.47-.29.9-.59 1.31-.9-.4-.42-.75-.85-1.05-1.29a.6.6 0 0 1 .18-.86l.33-.19.36-.21a.6.6 0 0 1 .8.17 9 9 0 0 0 .88 1.04 7.65 7.65 0 0 0 1.5-2.16H20.6A.6.6 0 0 1 20 6v-.8c0-.33.27-.6.6-.6h3.2v-.8c0-.33.27-.6.6-.6h.8c.33 0 .6.27.6.6v.8H29c.33 0 .6.27.6.6V6Zm1.2-6h-14v16h14c.66 0 1.2-.54 1.2-1.2V1.2c0-.66-.54-1.2-1.2-1.2ZM7.6 7.01a28.1 28.1 0 0 1-.38-1.66h-.03s-.22 1.06-.39 1.66l-.55 1.88h1.9L7.61 7Z",
    mask: "url(#b)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguages);
export default __webpack_public_path__ + "static/media/languages.f4c0c2afed743be4eb1fb683630d4086.svg";
export { ForwardRef as ReactComponent };